import { ApplicationLinkType } from "./application-link-type.model";
import { ApplicationOpenType } from "./application-open-type.model";

interface ApplicationBaseOptions {
	type?: ApplicationLinkType;
	openMode?: ApplicationOpenType;
}

export class ApplicationBase {

	public order: number = 999
	public type: ApplicationLinkType = ApplicationLinkType.AOC
	public openMode: ApplicationOpenType = ApplicationOpenType.SAME_TAB

	constructor(
		public code: string,
		public name: string,
		public url: string,
		public visualOrder: number,
		options: ApplicationBaseOptions = {}
	) {
		this.type = options.type ?? ApplicationLinkType.AOC;
		this.openMode = options.openMode ?? ApplicationOpenType.SAME_TAB;
	}

	static from(source: Application): ApplicationBase {

		let current = new ApplicationBase(source.code, source.name, source.url, source.visualOrder, { type: source.type, openMode: source.openMode });
		Object.assign(current, source);

		return current;
	}

	public resetOrder() {
		this.order = 999
	}

	public static cmp(a: ApplicationBase, b: ApplicationBase): number {
		if (a.order > b.order) {
			return 1
		}
		if (a.order == b.order) {
			return 0
		}
		return -1
	}

	static filterAndSortByVisualOrder(apps: ApplicationBase[], type: ApplicationLinkType): ApplicationBase[] {
		return apps
			.filter(app => app.type === type)
			.sort((a, b) => a.visualOrder - b.visualOrder);
	}


}

export interface Application extends ApplicationBase {

}
